import notify from 'devextreme/ui/notify';
import React, { useEffect } from 'react';
import useSWR from 'swr';
import { postApi } from '../../apiUtils';
import { Loader } from '../../components/loader/Loader';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { UserColorsForm } from '../../forms/userColors/UserColorsForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { CustomerInputs } from '../../types/customer.types';
import { UserColor, UserColorInputs } from '../../types/userColor.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function UsersColorNew() {
  const { translate } = useTranslation();
  const transFormName = 'UserColor.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New user color',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'User colors', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data: userColors, mutate: refetchUserColors } = useSWR<UserColor[]>(
    `${API_URL.USER_COLOR_LIST}`,
    fetcher,
    swrConfig,
  );

  const formData: UserColorInputs = {};

  const onSubmit = async (e) => {
    startLoading();
    if (e !== null) e.preventDefault();

    const userColor = userColors?.filter((uc) => uc.userId === formData.userId);
    if (userColor && userColor.length > 0) {
      stopLoading();
      notify(translate!('The user already has a color assigned', transFormName), 'error');
      return false;
    }

    let isOk = false;
    await postApi<CustomerInputs>({
      url: API_URL.USER_COLOR_CREATE,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
        refetchUserColors();
      },
    });
    stopLoading();
    return isOk;
  };

  if (!userColors) return <Loader />;
  return (
    <PageContentWrapper heading={translate!('New user color', transFormName)}>
      <UserColorsForm onSubmit={onSubmit} formData={formData} userColors={userColors} />
    </PageContentWrapper>
  );
}

export default UsersColorNew;
